const sidenav = {
  abandonedCallsBadge: 'MainLayout-Sidenav-AbandonedCallsBadge',
  secondChanceLeadsBadge: 'MainLayout-Sidenav-SecondChanceLeadsBadge',
  vaFollowUpsBadge: 'MainLayout-Sidenav-VaFollowUpsBadge',
  inboxPageNavButton: 'MainLayout-Sidenav-InboxPageNavButton',
  inboxCallsPageNavBtn: 'MainLayout-Sidenav-Inbox-CallsPageNavButton',
  // The id/data-testid the Messages SideNav.Item and its unread badge render.
  // MainLayout.tsx and MessagesNavBadge.tsx feed these constants to
  // getTestIdProps, so they are the single source of truth for both elements.
  // These two values predate this map and are what the product already emits,
  // so they keep that form rather than the MainLayout-Sidenav-* one used
  // above — realigning them would change the rendered DOM, not just this file.
  inboxMessagesTabTestId: 'side-nav-messages-tab',
  inboxMessagesBadgeTestId: 'side-nav-messages-tab-badge',
  audioSettingsNavBtn: 'MainLayout-Sidenav-AudioSettingsNavButton',
  audioSettingsErrorBadge: 'MainLayout-Sidenav-AudioSettingsErrorBadge',
  userManagementPageNavBtn: 'MainLayout-Sidenav-UserManagementPageNavButton',
  virtualAgentSettingPageNavBtn:
    'MainLayout-Sidenav-VirtualAgentSettingsPageNavButton',
  workflowManagementPageNavBtn:
    'MainLayout-Sidenav-WorkflowManagementPageNavButton',
  queueManagementPageNavBtn: 'MainLayout-Sidenav-QueueManagementPageNavButton',
  conversationHistoryPageNavBtn:
    'MainLayout-Sidenav-ConversationHistoryPageNavButton',
  abandonedCallsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-AbandonedCallsPageNavButton',
  secondChanceLeadsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-SecondChanceLeadsPageNavButton',
  voicemailsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-VoicemailsPageNavButton',
  virtualAgentsCallsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-VirtualAgentsCallsPageNavButton',
  queueMonitoringPageNavBtn: 'MainLayout-Sidenav-QueueMonitoringPageNavButton',
  callCenterMonitoringPageNavBtn:
    'MainLayout-Sidenav-CallCenterMonitoringPageNavButton',
  presetDaysTimesPageNavBtn: 'MainLayout-Sidenav-PresetDaysTimesPageNavButton',
  transferRecordingPageNavBtn:
    'MainLayout-Sidenav-TransferRecordingPageNavButton',
  callContinuityPageNavBtn: 'MainLayout-Sidenav-CallContinuityPageNavButton',
  globalRecordingPageNavBtn:
    'MainLayout-Sidenav-GlobalRecordingDefaultsPageNavButton',
  individualRecordingPageNavBtn:
    'MainLayout-Sidenav-IndividualRecordingPageNavButton',
  queueRecordingPageNavBtn: 'MainLayout-Sidenav-QueueRecordingPageNavButton',
  exclusionListPageNavBtn: 'MainLayout-Sidenav-ExclusionListPageNavButton',
  callAnalysisPageNavBtn: 'MainLayout-Sidenav-CallAnalysisPageNavButton',
  dataIntegrationPageNavBtn: 'MainLayout-Sidenav-DataIntegrationPageNavButton',
  inboxTaskCardsPageNavBtn: 'MainLayout-Sidenav-InboxTaskCardsPageNavButton',
  liveServicesPhoneMappingPageNavBtn:
    'MainLayout-Sidenav-LiveServicesPhoneMappingPageNavButton',
  outboundNumbersPageNavBtn: 'MainLayout-Sidenav-OutboundNumbersPageNavButton',
  powerDialerPageNavBtn: 'MainLayout-Sidenav-PowerDialerPageNavButton',
  voiceIntelligenceSettingsPageNavBtn:
    'MainLayout-Sidenav-VoiceIntelligenceSettingsPageNavButton',
  voiceIntelligenceCoachingHubPageNavBtn:
    'MainLayout-Sidenav-VoiceIntelligenceCoachingHubPageNavButton',
  jobBookingPageNavBtn: 'MainLayout-Sidenav-JobBookingPageNavButton',
} as const;

const outboundAndTransferModal = {
  employeeRowRadioBtn: 'Layout-OutboundAndTransferModal-EmployeeRowRadioBtn',
  technicianRowRadioBtn:
    'Layout-OutboundAndTransferModal-TechnicianRowRadioBtn',
  keypadBtn: 'Layout-OutboundAndTransferModal-KeypadBtn',
  primaryActionBtn: 'Layout-OutboundAndTransferModal-PrimaryActionBtn',
  secondaryActionBtn: 'Layout-OutboundAndTransferModal-SecondaryActionBtn',
  keypadInput: 'Layout-OutboundAndTransferModal-KeypadInput',
  technicianCallBtn:
    'Layout-OutboundAndTransferModal-TechnicianConfirmationModal-CallButton',
  queueFallbackWarningIcon:
    'Layout-OutboundAndTransferModal-QueueFallbackWarningIcon',
} as const;

const outboundCallerIdModal = {
  numberRowRadioBtn: 'Layout-OutboundCallerIdModal-NumberRadioButtonCell',
} as const;

const navBar = {
  disconnectButton: 'MainLayout-NavBar-DisconnectButton',
  reconnectButton: 'MainLayout-NavBar-ReconnectButton',
  logo: 'MainLayout-NavBar-Logo',
  title: 'MainLayout-NavBar-Title',
  userStatusMenu: 'MainLayout-NavBar-UserStatusMenu',
  userStatusMenuOption: 'MainLayout-NavBar-UserStatusMenuOption',
  settingsBtn: 'Layout-NavBar-SettingsBtn',
  managerAssistBtn: 'Layout-NavBar-ManagerAssistBtn',
  callBtnIcon: 'Inbox-CallBar-CallButtonIcon',
  helpCenterBtn: 'Layout-NavBar-HelpCenterBtn',
  resetAccountBtn: 'MainLayout-NavBar-ResetAccountBtn',
  outboundCallModal: 'MainLayout-NavBar-OutboundCallModal',
} as const;

const userMenu = {
  openButton: 'MainLayout-Navbar-UserMenu-ActionMenu',
  userNameLabel: 'MainLayout-Navbar-UserMenu-UserName',
  refreshStatusButton: 'MainLayout-Navbar-UserMenu-RefreshStatusButton',
  makeTestCallButton: 'MainLayout-Navbar-UserMenu-MakeTestCallButton',
} as const;

const resetAccountModal = {
  dialog: 'MainLayout-ResetAccountModal-Dialog',
  acknowledgementCheckbox:
    'MainLayout-ResetAccountModal-AcknowledgementCheckbox',
  keepTasksRadio: 'MainLayout-ResetAccountModal-KeepTasksRadio',
  clearTasksRadio: 'MainLayout-ResetAccountModal-ClearTasksRadio',
  resetButton: 'MainLayout-ResetAccountModal-ResetButton',
  cancelButton: 'MainLayout-ResetAccountModal-CancelButton',
} as const;

const audioSettingsModal = {
  dialog: 'MainLayout-AudioSettingsModal-Dialog',
  closeButton: 'MainLayout-AudioSettingsModal-CloseButton',
} as const;

const toastGroup = {
  toast: 'Layout-ToastGroup-Toast',
};

const announcements = {
  defaultCallerIdNotConfigured:
    'MainLayout-Announcements-DefaultCallerIdNotConfigured',
  rtcsConnectionStatus: 'MainLayout-Announcements-RtcsConnectionStatus',
} as const;

export const mainLayoutLocators = {
  sidenav,
  navBar,
  toastGroup,
  outboundAndTransferModal,
  userMenu,
  resetAccountModal,
  audioSettingsModal,
  outboundCallerIdModal,
  announcements,
} as const;
